import React from "react";
import pilLogo from "assets/images/pil-logo.png";

const PILBadge = () => {
  return (
    <img
      src={pilLogo}
      alt="PIL"
      style={{
        width: "40px",
        height: "40px",
        borderRadius: "8px",
        objectFit: "cover",
      }}
    />
  );
};

export default PILBadge;
